import { useParams, useNavigate } from "react-router-dom";
import { topics } from "@/mocks/topics";
import { comics } from "@/mocks/comics";
import ComicCard from "@/components/feature/ComicCard";

export default function TopicDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const topic = topics.find((t) => t.id === Number(id));

  if (!topic) {
    return (
      <div className="container-x flex flex-col items-center py-24 text-center">
        <i className="ri-error-warning-line text-5xl text-foreground-300"></i>
        <p className="mt-4 font-heading text-xl font-bold text-foreground-700">这篇专题不存在或已下架</p>
        <button onClick={() => navigate("/topics")} className="mt-5 btn-primary">返回专题列表</button>
      </div>
    );
  }

  const others = topics.filter((t) => t.id !== topic.id).slice(0, 3);
  const recommended = comics.slice(0, 4);

  return (
    <div>
      <section className="relative w-full overflow-hidden">
        <div className="relative h-56 w-full md:h-72">
          <img src={topic.image} alt={topic.title} className="absolute inset-0 h-full w-full object-cover object-center" />
          <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/85 via-foreground-950/40 to-foreground-950/30"></div>
          <div className="relative z-10 container-x flex h-full flex-col justify-end pb-8">
            <nav className="flex items-center gap-1.5 text-sm text-background-300" aria-label="面包屑">
              <button onClick={() => navigate("/")} className="cursor-pointer hover:text-background-50">首页</button>
              <i className="ri-arrow-right-s-line"></i>
              <button onClick={() => navigate("/topics")} className="cursor-pointer hover:text-background-50">题材专题</button>
              <i className="ri-arrow-right-s-line"></i>
              <span className="text-accent-300">{topic.category}</span>
            </nav>
            <h1 className="mt-3 max-w-3xl font-heading text-2xl font-bold leading-snug text-background-50 md:text-3xl">{topic.title}</h1>
          </div>
        </div>
      </section>

      <div className="container-x grid grid-cols-1 gap-8 py-10 lg:grid-cols-3">
        {/* 正文 */}
        <article className="lg:col-span-2">
          <div className="flex flex-wrap items-center gap-x-4 gap-y-2 border-b border-background-300/60 pb-5 text-sm text-foreground-500">
            <span className="tag-chip">{topic.category}</span>
            <span className="flex items-center gap-1"><i className="ri-calendar-line"></i>{topic.date}</span>
            <span className="flex items-center gap-1"><i className="ri-time-line"></i>{topic.readTime}阅读</span>
            <span className="flex items-center gap-1"><i className="ri-eye-line"></i>2.6k</span>
          </div>

          <div className="mt-6 space-y-5">
            <p className="border-l-2 border-primary-500 pl-4 text-base font-medium leading-relaxed text-foreground-800">
              {topic.summary}
            </p>
            {topic.content.map((para, i) => (
              <p key={i} className="text-base leading-8 text-foreground-700">
                {para}
              </p>
            ))}
          </div>

          <div className="mt-8 flex flex-wrap gap-2 border-t border-background-300/60 pt-5">
            {topic.tags.map((t) => (
              <button
                key={t}
                onClick={() => navigate(`/category?tag=${encodeURIComponent(t)}`)}
                className="rounded-full bg-secondary-100 px-3.5 py-1.5 text-sm text-secondary-900 hover:bg-secondary-200 cursor-pointer"
              >
                #{t}
              </button>
            ))}
          </div>
        </article>

        {/* 侧栏 */}
        <aside className="space-y-8">
          <div className="rounded-lg border border-background-300/60 bg-background-100 p-5">
            <h3 className="flex items-center gap-2 font-heading text-lg font-bold text-foreground-950">
              <span className="h-px w-5 bg-primary-500"></span>相关专题
            </h3>
            <div className="mt-4 space-y-4">
              {others.map((o) => (
                <button key={o.id} onClick={() => navigate(`/topic/${o.id}`)} className="group flex w-full gap-3 text-left cursor-pointer">
                  <img src={o.image} alt={o.title} className="h-16 w-20 shrink-0 rounded-md object-cover" loading="lazy" />
                  <div className="min-w-0">
                    <p className="line-clamp-2 text-sm font-semibold leading-snug text-foreground-800 group-hover:text-primary-600">{o.title}</p>
                    <p className="mt-1 text-xs text-foreground-500">{o.category} · {o.readTime}</p>
                  </div>
                </button>
              ))}
            </div>
          </div>
        </aside>
      </div>

      {/* 相关漫画 */}
      <section className="container-x pb-12">
        <h2 className="flex items-center gap-2 font-heading text-xl font-bold text-foreground-950">
          <span className="h-px w-5 bg-primary-500"></span>延伸阅读 · 相关漫画
        </h2>
        <div className="mt-4 grid grid-cols-2 gap-4 sm:grid-cols-3 md:gap-5 lg:grid-cols-4">
          {recommended.map((c) => (
            <ComicCard key={c.id} comic={c} />
          ))}
        </div>
      </section>
    </div>
  );
}